<template>
<div class="main">
  <div class="container">
    <!-- <h2>create an account</h2> -->
     <div
        class="signup-form wizard clearfix"
      >
    <div class="steps clearfix text-center">
      <img src="/assets/img/icon-push-notification-64.png" />   
    </div>
    <div class="content clearfix">
      <div class="tab-pane active" id="form-step-1">
        <div class="row text-center">
          <div class="col-sm-12">
            <h4 class="info-text ">
              You already have an account with us.
            </h4>
            <p>Need help?</p>
            <p>You can contact
                    us on:<br /><br />
                    <span class="fa fa-envelope"></span>&nbsp;<a
                      href="mailto:onboarding@smartcurrencyexchange.com"
                      >onboarding@smartcurrencyexchange.com</a
                    ><br /><br />
                     <span class="fa fa-phone-square"></span>&nbsp;<a
                      href="tel:+442078980541"
                      >+44 20 7898 0541</a
                    ></p>
          </div>
          <div class="col-sm-12 mt-3">
        <input
          type="button"
          class="btn btn-fill btn-success btn-block btn-wd btn-md"
          name="goback"
          value="Go back"
          @click.prevent="goback()"
        />
      </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</template>
<script>
export default {
  name:"ExistingClient",
  methods:{
    goback(){
 this.$router.push({ name: 'Home' ,params: { cleanForm: true}});
    }
  }
}
</script>
<style scoped>
.title-big{
    width: 150px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
}
.steps ul, .form-row {
    flex-direction: column;
}
.fa { font-size:18px;}
</style>